/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { useState, useEffect, useRef } from 'react'; // eslint-disable-next-line
import { copiriAxiosPost, copiriPortalRequest, checkValidation } from '../../../api/api'; // eslint-disable-next-line
import config from '../../../config/config'; // eslint-disable-next-line
import { toast } from 'react-toastify';
// eslint-disable-next-line
import FormGroupInput from '../../../common/FormGroupInput';
import { Row, Col, Button } from 'react-bootstrap';
// eslint-disable-next-line
import CopiriLoader from '../../../common/CopiriLoader';
import image_loader from '../../../../assets/img/loader/small_loader.gif'; // eslint-disable-next-line
const InstagramField = props => {
	// eslint-disable-next-line
	const { lodgeData, id, closeModal, updateLodgeModal, pageLanguageContent } = props; // eslint-disable-next-line
	const [checkDataChange, setCheckDataChange] = useState(false);
	const [showLoader, setShowLoader] = useState(false);
	const [inputField, setInputField] = useState({
		instagram: ''
	});
	const [validation, setValidation] = useState({
		error_instagram: ''
	});

	useEffect(() => {
		if (props.id) {
			const { instagram } = lodgeData.social;
			setInputField({ ...inputField, instagram });
		}
		// eslint-disable-next-line
	}, [props.id]);

	const inputsHandler = e => {
		setCheckDataChange(true);
		setInputField({ ...inputField, [e.target.name]: e.target.value });
	};

	function updateData() {
		let errors = { ...validation };
		var errorCount = 0;
		var checkError = checkValidation(inputField.instagram, 'url');
		if (!inputField.instagram) {
			errors.error_instagram = pageLanguageContent['CLD071'];
			errorCount++;
		} else if (!checkError) {
			errors.error_instagram = pageLanguageContent['CLD077'];
			errorCount++;
		} else {
			errors.error_instagram = '';
		}
		var sendData = {};
		sendData['value'] = inputField['instagram'];
		sendData['type'] = 'Instagram';

		setValidation(errors);
		if (errorCount <= 0) {
			setShowLoader(true);
			copiriPortalRequest('/organizations/' + id + '/additional-info', config.app_version, 'patch', sendData)
				.then(response => {
					setShowLoader(false);
					if (response.data.status && response.data.status === 'SUCCESS') {
						toast.success(pageLanguageContent['CLD119']);
						closeModal();
						updateLodgeModal('social', inputField['instagram'], 'instagram', '');
					}
				})
				.catch(error => {
					toast.error(error.response.data.result);
					setShowLoader(false);
				});
		}
	}
	return (
		<Row className='mt-2'>
			<Col lg={12}>
				<FormGroupInput
					id='instagram'
					label={pageLanguageContent['CLD038'] ? pageLanguageContent['CLD038'] : ''}
					placeholder={pageLanguageContent['CLD179'] ? pageLanguageContent['CLD179'] : ''}
					type='text'
					name='instagram'
					onChange={inputsHandler}
					value={inputField.instagram}
				/>
				{validation.error_instagram && <p className='formValidationError'>{validation.error_instagram}</p>}
			</Col>
			<Col lg={12}>
				{inputField.instagram && (
					<p style={{ position: 'absolute' }}>
						<a
							href={inputField.instagram}
							target='_blank'
							rel='noopener noreferrer'
							data-toggle='tooltip'
							title={inputField.instagram}
						>
							{pageLanguageContent['CLD190'] ? pageLanguageContent['CLD190'] : ''}
						</a>
					</p>
				)}
				<Button
					variant='primary'
					id={'confirmValidatebutton'}
					style={{ float: 'right', marginBottom: '15px' }}
					onClick={updateData}
				>
					{showLoader ? (
						<img src={image_loader} alt='loader' height='20' width='20' />
					) : pageLanguageContent['CLD124'] ? (
						pageLanguageContent['CLD124']
					) : (
						''
					)}
				</Button>
			</Col>
		</Row>
	);
};
export default InstagramField;
